module.exports = __webpack_public_path__ + "img/trending-up.137bd978.svg";